// extracted by mini-css-extract-plugin
export default {"priority":"RequestPrioritySelect_priority__r20sH","priorityColor":"RequestPrioritySelect_priorityColor__lriwT"};